<template>
  <div class="tab-pane">
    <div class="row" v-if="userType == 'student'">
      <div class="col-md-12 overflow-auto">
        <b-card no-body>
          <b-card-header>
            <h4 class="mb-0">{{ $t("attendance.percentage") }}</h4>
          </b-card-header>

          <!-- apex chart -->
          <vue-apex-charts
            type="radialBar"
            height="180"
            :options="goalOverviewRadialBar.chartOptions"
            :series="series"
          />
        </b-card>
      </div>
    </div>
    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template v-if="userType !== 'student'" #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                v-model="recordIds"
                type="checkbox"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span />
            </label>
          </template>
          <template #cell(description)="data">
            <div v-html="data.item.description"></div>
          </template>
          <template #cell(attendance)="data">
            <h6>
              <span
                class="badge badge-success"
                v-if="data.item.attendance == 'attend'"
                >{{ $t("attendance.attend") }}</span
              >
              <span
                class="badge badge-danger"
                v-if="data.item.attendance == 'absence'"
                >{{ $t("attendance.absence") }}</span
              >
              <span
                class="badge badge-warning"
                v-if="data.item.attendance == 'excuse'"
                >{{ $t("attendance.excuse") }}</span
              >
            </h6>
          </template>
          <template #cell(excuse_request)="data">
            <b-button v-b-modal.modal-info variant="outline-info">
              {{ $t("attendance.ask_for_excuse") }}
            </b-button>
          </template>
          <!-- <template #cell(assign_students)="data">
            <b-button
              v-b-modal.modal-info
              variant="outline-info"
              @click="
                assignStudents(
                  data.item,
                  'student',
                  $t('rooms.assign_students')
                )
              "
            >
              {{ $t("rooms.assign_students") }}
            </b-button>
          </template> -->
        </b-table>

        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal
      id="modal-info"
      ok-only
      ok-variant="info"
      modal-class="modal-info"
      centered
      @hide="hide"
      size="lg"
      title="title"
    >
      <!-- <b-spinner v-else type="grow" label="Loading..." /> -->
    </b-modal>
  </div>
</template>

<script>
import controller from "@/Controllers/SessionAttendanceController";
 import Auth from "@/Apis/Auth";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
 
export default {
  name: "OnlineSessionDataTable",
  props: ["items", "editItem"],
  components: {
    VueApexCharts,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
        {
          key: "title",
          label: this.$i18n.t("online_session.title"),
          sortable: true,
        },
        {
          key: "description",
          label: this.$i18n.t("online_session.description"),
          sortable: true,
        },
        {
          key: "start_in",
          label: this.$i18n.t("online_session.start_in"),
          sortable: true,
        },
        {
          key: "end_in",
          label: this.$i18n.t("online_session.end_in"),
          sortable: true,
        },
        {
          key: "attendance",
          label: this.$i18n.t("attendance.attendance"),
          sortable: true,
        },
        {
          key: "excuse_request",
          label: this.$i18n.t("attendance.excuse_request"),
          sortable: false,
        },
        ],
      },
      series: [0],
      goalOverviewRadialBar: {
        chartOptions: {
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: ["#51e5a8"],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77",
              },
              track: {
                background: "#ebe9f1",
                strokeWidth: "50",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: "#5e5873",
                  fontSize: "2.86rem",
                  fontWeight: "600",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      userType: Auth.USER.account_type,
      user: Auth.USER,
    };
  },
  created() {

  },
  methods: {
    checkTime(item) {
      const datanow = new Date();
      console.log(item.start_in);

      const stDate = new Date(item.start_in);
      const enDate = new Date(item.end_in);

      if (stDate.getTime() <= datanow && datanow <= enDate) return true;
      return false;
    },
    openLive(data) {
      new controller().joinLecture(data.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.original.current_page;
      this.perPage = data.original.per_page;
      this.totalRows = data.original.total;
      this.from = data.original.from;
      this.to = data.original.to;
      this.total = data.original.total;
      this.data = this.dataHandle(data.original.data, data.helpers);
      this.series = [this.percentage(data.original.total, data.helpers)];
      this.load = false;
      return this.data;
    },
    dataHandle(data, sessionattendance) {
      let attended = {};
      data.map((obj) => {
        if (Auth.USER.account_type == "student") {
          attended = sessionattendance.find(
            (a) => a.online_session_id == obj.id
          );
        } else {
          attended = sessionattendance.find((a) => a.user_id == obj.id);
        }
        if (attended) {
          obj["attendance"] = attended.excuse_id ? "excuse" : "attend";
        } else {
          obj["attendance"] = "absence";
        }
      });
      return data;
    },
    percentage(total, sessionattendance) {
      return total > 0 ? (sessionattendance.length * 100) / total : 0;
    },
    async hide() {
      //here we will type logic
      this.$refs.table.refresh();
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage, datenow: new Date() };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (Auth.USER.account_type == "student") {
        let id = localStorage.getItem("eduProgram");
        let room = Auth.ROOM.find((a) => a.edu_program_id == id);
        if (room) apiParams.filter = "room_id|" + room.id;
      }

      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
